<template>
  <div class="meeting-disabled">
    <div class="meeting-disabled--date">
      <h1 class="meeting-disabled--date__weekday">{{ textualDayOfWeek }}</h1>
      <p class="meeting-disabled--date__hour">{{ time }}</p>
      <h1 class="meeting-disabled--date__day">{{ dayOfWeek }}</h1>
      <p class="meeting-disabled--date__monthyear">{{ monthAndYer }}</p>
    </div>
    <div class="meeting-disabled--description">
      <h1 class="meeting-disabled--description__title">
        {{ meeting_type_description }}
        <span class="meeting-disabled--description__subtitle">
          {{ vacancy_title }}
        </span>
      </h1>
      <p class="meeting-disabled-description__markedby">
        <vs-icon icon="person" />Entrevista marcada por {{ scheduledBy }}
      </p>
      <p class="meeting-disabled-description__address">
        <vs-icon icon="room" />Avenida Segismundo Pereira, 1352
      </p>
      <p class="meeting-disabled-description__message">
        <vs-icon icon="mode_comment" /> {{ description }}
        <a v-if="showMore" @click="moreDescription">{{
          `${!fullDescription ? "ver mais" : "ver menos"}`
        }}</a>
      </p>
    </div>
    <div class="meeting-disabled--actions">
      <div class="meeting-disabled--label">{{ label }}</div>
      <span class="meeting-disabled--label__description">
        {{ labelDescription }}
      </span>
    </div>
  </div>
</template>

<script>
import {
  isSunday,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
} from "date-fns";

export default {
  name: "meeting-card-disabled",
  props: {
    meeting: {
      type: Object,
      required: true,
    },
    expired: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    label() {
      return this.meeting.meeting_status_id == 2
        ? "Proposta rejeitada"
        : "Convite expirado";
    },

    labelDescription() {
      return this.meeting.meeting_status_id == 2
        ? `Proposta rejeitada no dia ${this.meeting.date}`
        : `Convite expirado no dia ${this.meeting.date}`;
    },

    textualDayOfWeek() {
      let textualWeekDay = "";

      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        if (isSunday(date)) {
          textualWeekDay = "Domingo";
        }
        if (isMonday(date)) {
          textualWeekDay = "Segunda";
        }
        if (isTuesday(date)) {
          textualWeekDay = "Terça";
        }
        if (isWednesday(date)) {
          textualWeekDay = "Quarta";
        }
        if (isThursday(date)) {
          textualWeekDay = "Quinta";
        }
        if (isFriday(date)) {
          textualWeekDay = "Sexta";
        }
        if (isSaturday(date)) {
          textualWeekDay = "Sábado";
        }
      }
      return textualWeekDay;
    },

    dayOfWeek() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        return splited[0];
      }
      return "";
    },

    monthAndYer() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        return date
          .toLocaleString("pt-BR", { month: "long" })
          .slice(0, 3)
          .toUpperCase()
          .concat("/")
          .concat(`${date.toLocaleString("pt-BR", { year: "numeric" })}`);
      }
      return "";
    },

    time() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("time")
        ? this.meeting.time.slice(0, 5)
        : "";
    },

    place() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("place")
        ? this.meeting.place
        : "";
    },

    status() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_status")
        ? this.meeting.meeting_status["description"]
        : "";
    },

    status_message() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status")
        ? "Compareça no local e hora indicados"
        : "Esperando o aceite do horário sugerido";
    },

    status_class() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status")
        ? "meeting--label__success"
        : "meeting--label__alert";
    },

    meeting_type_description() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_type")
        ? this.meeting.meeting_type["description"]
        : "";
    },

    vacancy_title() {
      return this.meeting !== undefined &&
        this.meeting !== null &&
        this.meeting.hasOwnProperty("vacancy") &&
        this.meeting.vacancy !== null
        ? this.meeting.vacancy["title"]
        : "";
    },

    scheduledBy() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("manager")
        ? this.meeting.manager["user"].name
        : "";
    },

    description() {
      if (
        this.meeting != undefined &&
        this.meeting.hasOwnProperty("comment") &&
        this.meeting.comment != null
      ) {
        if (!this.fullDescription) return this.meeting.comment.slice(0, 184);
        return this.meeting.comment;
      }
      return "";
    },

    showMore() {
      if (
        this.meeting != undefined &&
        this.meeting.hasOwnProperty("comment") &&
        this.meeting.comment != null
      ) {
        return this.meeting.comment.length > 184;
      }
    },
  },
  methods: {
    onShowDescription() {
      return (
        this.meeting !== undefined &&
        this.meeting.hasOwnProperty("comment") &&
        this.meeting.comment != null
      );
    },

    moreDescription() {
      this.fullDescription = !this.fullDescription;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/meetingcarddisabled.scss";
</style>
